import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { iModalConfirm } from '../../interfaces/modal-confirm.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-confirm',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './modal-confirm.component.html',
  styleUrl: './modal-confirm.component.scss'
})
export class ModalConfirmComponent {
  private dialogRef = inject(MatDialogRef<ModalConfirmComponent>);
  public data = inject<iModalConfirm>(MAT_DIALOG_DATA);

  constructor() {
    this.dialogRef.disableClose = this.data.noCloseByOutsideClick === true;
  }

  handleClickButton(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
